fccd-results-found {
  div.query-info:focus {
    outline: none;
  }
  // care-practitioner-listing text wraps in medium view so wrap the text
  // so it's balanced instead of only the last 'word' being on the next line
  .wrap {
    text-wrap: balance;
  }
}
